import React from "react"

import Parameters from "~components/Parameters"
import Title from "./Title"
import Detail from "./Detail"
import Description from "./Description"
import Enum from "./Enum"
import Editor from "./Editor"

import * as style from "./Parameter.module.scss"

const Parameter = ({
  param, parent, hideExtras, explorer, microcopy,
}) => (
  <div
    className={style.item}
    id={encodeURI(param.anchor)}
    data-field-variant={param.variant}
  >
    <div className={style.padded}>
      <Title
        hideExtras={hideExtras}
        param={param}
        microcopy={microcopy}
        parent={parent}
      />
      <Detail param={param} microcopy={microcopy} />
      {explorer && param.type !== "object" && !(param.location === "header" && param.key === "box-version") && (
        <Editor explorer={explorer} param={param} />
      )}
      {param.showDescription && <Description param={param} />}
      {param.enum?.[0] && <Enum param={param} microcopy={microcopy} />}
    </div>
    {!param.resource && !param.resources && param.params?.[0] && (
      <div className={style.indent}>
        <Parameters
          explorer={explorer}
          hideExtras={hideExtras}
          parent={param}
          params={param.params}
        />
      </div>
    )}
  </div>
)

export default Parameter
